import { MapPin, Truck } from "lucide-react";
import { money } from "../lib/api";

const icons = { pickup: MapPin, courier: Truck };

export const ShippingPicker = ({ options, value, onChange }) => {
  const entries = Object.entries(options || {});
  if (!entries.length) return null;
  return (
    <fieldset data-testid="shipping-picker">
      <legend className="font-semibold mb-2">Delivery</legend>
      <div className="grid sm:grid-cols-2 gap-3">
        {entries.map(([key, o]) => {
          const Icon = icons[key] || Truck;
          const active = value === key;
          return (
            <button type="button" key={key} data-testid={`shipping-option-${key}`} onClick={() => onChange(key)}
              className={`text-left rounded-2xl border-2 border-[var(--ink)] p-4 flex gap-3 transition-colors ${active ? "bg-[var(--cyan)] shadow-[4px_4px_0_#14101F]" : "bg-white hover:bg-[var(--paper)]"}`}>
              <Icon className="w-5 h-5 mt-0.5 shrink-0" />
              <span className="flex-1">
                <span className="flex justify-between gap-2 font-bold">
                  <span>{o?.label}</span><span className="font-mono-x">{o?.fee ? money(o.fee) : "Free"}</span>
                </span>
                <span className="block text-sm text-[#3b3550] mt-0.5">{o?.detail}</span>
              </span>
            </button>
          );
        })}
      </div>
    </fieldset>
  );
};
